import React from 'react';
import { Box, Typography } from '@material-ui/core'
import { Button } from "@paro.io/base-ui";
import { IconCheck, IconUser } from '@paro.io/base-icons';
import { MailLogo, VerificationBox } from '../../../Registration/AccountVerification';

const Step3 = () => {
    const [loadingExpertPortal, setLoadingExpertPortal] = React.useState<boolean>(false);

    return (
        <Box sx={{ flex: 1, padding: 50 }}>
            <VerificationBox>
                <Box
                    display="flex"
                    alignContent="center"
                    alignItems="center"
                    justifyContent="center"
                    flexDirection="column"
                    padding="100px 0px 36px 5px;"
                >
                    <MailLogo>
                        <IconCheck size="lg" className="w-10 h-10" />
                    </MailLogo>

                    <Typography className="text-center px-4">
                        <h3 className="font-bold">You’re Ready to Scale Smarter</h3>
                    </Typography>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            padding: 25,
                            justifyContent: 'flex-start',
                            alignItems: 'flex-start',
                        }}
                    >
                        <Typography variant="subtitle1" className="text-center px-4">
                            <b>All your clients have been successfully imported.</b>
                        </Typography>
                        <Typography variant="subtitle1" className="text-center px-4">
                            Keep the momentum going as you go into the platform:
                        </Typography>
                        <ul style={{ marginLeft: 50, marginBottom: 8, listStyleType: 'disc' }}>
                            <li>Set up your firm profile and add payment info</li>
                            <li>Start building automated contracts, invoices & reports</li>
                            <li>Explore the AI agent library to automate routine tasks</li>
                            <li>Use AI agents to automate document collection and reconciliation prep</li>
                            <li>Leverage smart project management to track tasks and deadlines automatically</li>
                            <li>Access client communication tools to keep everyone aligned</li>
                            <li>Time tracking and billing in one place</li>
                        </ul>
                        <Typography variant="subtitle1" className="text-center px-4">
                            <b>Next, sign in to start using AI-powered tools that help you grow your practice.</b>
                        </Typography>
                        <Typography variant="caption" className="text-center px-4">
                            Use the email and password from Step 1 — you’ll be up and running in 30 seconds.
                        </Typography>
                    </Box>
                    <Button
                        label="Take Me To The AI Growth Platform"
                        id="enterThePlatform"
                        color="primary"
                        iconLeft={<IconUser size="sm" />}
                        onClick={() => {
                            setLoadingExpertPortal(true);
                            window.location.assign(`${process.env.REACT_APP_EXPERT_PORTAL_URL}/dashboardsV2?tab=aigp`);
                        }}
                        isLoading={loadingExpertPortal}
                    />
                </Box>
            </VerificationBox>
        </Box>
    )
}

export default Step3;